<div class="map-layers-assembly container">
  <mtn-map-toolbar-button icon="layer-group" [badgeCount]="toolbarState.badgeCountLayers"
                          [color]="toolbarState.badgeCountLayers ? 'green' : 'grey'"
                          [iconColor]="toolbarState.badgeCountLayers ? 'green' : 'default'"
                          mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.TOGGLE_MENU"
                          [analyticsEventParameters]="{'target': 'map-layers-menu'}"
                          [matTooltip]="'MAP_LAYERS.TOOLTIP' | translate"
                          [matMenuTriggerFor]="layersMenu">
  </mtn-map-toolbar-button>
</div>

<mat-menu class="wide-menu" #layersMenu="matMenu">
  <div class="layers-menu-container toolbar-menu container" mtnClickTrap [preventDefault]="false">
    <div fxLayout="row">
      <strong>{{ 'MAP_LAYERS.HEADER' | translate }}</strong>
      <div fxFlex></div>
      <a class="color-accent" href="javascript:void(0)" (click)="clearAll()">
        {{ 'MAP_LAYERS.CLEAR_ALL' | translate }}
      </a>
    </div>
    <hr/>
    <div fxLayout="column" [formGroup]="form">
      <mat-checkbox color="accent" [disabled]="true">
        {{ 'MAP_LAYERS.RETAIL_STAT_SC' | translate }}
      </mat-checkbox>
      <mat-checkbox color="accent" formControlName="isStoreLayerEnabled">
        {{ 'MAP_LAYERS.RETAIL_STAT_STORES' | translate }}
      </mat-checkbox>
      <mat-checkbox color="accent" formControlName="isPointsOfInterestLayerEnabled">
        {{ 'MAP_LAYERS.POI_GOOGLE' | translate }}
      </mat-checkbox>
      <mat-checkbox color="accent" [disabled]="true">
        {{ 'MAP_LAYERS.THEMATICS' | translate }}
      </mat-checkbox>
    </div>
  </div>
</mat-menu>
